(function() {
    const init = () => {
        console.log('[PINNED_TEST] 脚本开始运行'); // 改用 log 替代 alert 方便调试
        
        // 1. 移除严苛的 class 检查，改用更通用的检查
        const container = document.querySelector('.t4s-products');
        if (!container) {
            console.log('[PINNED_TEST] 未找到产品容器');
            return;
        }

        const pinnedHandle = new URLSearchParams(window.location.search).get('pinned');
        console.log('[PINNED_TEST] 找到参数:', pinnedHandle);
        if (!pinnedHandle) return;

        // 执行置顶逻辑...
        const target = Array.from(container.querySelectorAll('.t4s-product')).find(el => 
            el.dataset.handle === pinnedHandle || el.querySelector(`a[href*="/products/${pinnedHandle}"]`)
        );

        if (target) {
            container.insertBefore(target, container.firstChild);
            console.log('[PINNED_TEST] 置顶成功');
        }
    };

    // 🚀 核心修改：不依赖 DOMContentLoaded，直接使用递归自检
    const checkReady = () => {
        if (document.querySelector('.t4s-products')) {
            init();
        } else {
            // 如果没找到容器，每 200ms 检查一次，最多找 20 次（4秒）
            if (!window.checkCount) window.checkCount = 0;
            if (window.checkCount < 20) {
                window.checkCount++;
                setTimeout(checkReady, 200);
            }
        }
    };

    checkReady();
})();